// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__DomStringMap from "melange-webapi/Webapi/Dom/Webapi__Dom__DomStringMap.jsx";
import * as React from "react";

function use(param) {
  return React.useCallback((function (lock) {
    Stdlib__Option.iter((function (dataset) {
      if (lock) {
        return Webapi__Dom__DomStringMap.set("scrollLock", "", dataset);
      } else {
        return Webapi__Dom__DomStringMap.unsafeDeleteKey("scrollLock", dataset);
      }
    }), Stdlib__Option.map((function (prim) {
      return prim.dataset;
    }), Stdlib__Option.map((function (prim) {
      return prim;
    }), Caml_option.nullable_to_opt(document.body))));
  }), []);
}

export {
  use,
}
/* react Not a pure module */
